import { FLYOVER_LAUNCHERS, installLazyLaunchers } from './lazyLaunchers';
import { showFlyoverLoadingOverlay } from './loadingOverlay';

const targetElement = document.querySelector('#flyover_preview');

if (targetElement) {
  const { preload } = installLazyLaunchers(
    window as unknown as Record<string, unknown>,
    FLYOVER_LAUNCHERS,
    () => {
      // Started alongside the chunk download rather than after it: for a signed-in viewer it's a
      // network call, and the flyover needs its answer before it can pick the map style.
      const isProOrProPlus = import('../../utils/RevenueCatWrapper').then(({ RevenueCatWrapper }) =>
        RevenueCatWrapper.isProOrProPlus()
      );
      return import('./mountFlyoverPreview').then(({ mountFlyoverPreview }) =>
        mountFlyoverPreview(targetElement, isProOrProPlus)
      );
    },
    { onWait: () => showFlyoverLoadingOverlay() }
  );

  // A pointer over (or focus on) the hike page's 3D flyover button is a strong hint it's about to be
  // pressed, so start loading then and the click usually finds the app ready.
  const warmUp = (event: Event) => {
    if ((event.target as Element | null)?.closest?.('.show-mapbox-modal')) void preload();
  };
  document.addEventListener('pointerover', warmUp, { passive: true });
  document.addEventListener('focusin', warmUp);
}
